export default {
  VIDEO_READY: 'VIDEO_READY',
};
